/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const switchOrganisationInputDataSchema = z.object({
	organisationId: z.string(),
})

export type SwitchOrganisationInputDataSchema = z.infer<typeof switchOrganisationInputDataSchema>
